import styled, { css } from 'styled-components';
import { Button } from '@/components/UI/Button/Button';
import { BtnPosition } from '@/components/AdImages/AdImages.types';
import { IconBox } from '@/components/UI/IconBox/IconBox.styles';
import { centerAbsolute } from '@/styles/helpers';

function getStylesForBtnPosition(position?: BtnPosition, isSmall?: boolean) {
  const side = isSmall ? '3px' : '5px';
  switch (position) {
    case 'tr': {
      return css`
        top: ${side};
        right: ${side};
      `;
    }
    case 'br': {
      return css`
        bottom: ${side};
        right: ${side};
      `;
    }
    case 'bl': {
      return css`
        bottom: ${side};
        left: ${side};
      `;
    }

    default: {
      return css``;
    }
  }
}

export const AdImagesItemBox = styled.div<{ $isSmall?: boolean }>`
  aspect-ratio: 1;
  display: flex;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 14px;
  background-color: ${({ theme }) => theme.palette.secondary.background};

  ${({ $isSmall }) =>
    $isSmall &&
    css`
      height: 70px;
      width: 70px;
    `}

  user-select: none;
  -webkit-touch-callout: none;
`;

export const AdImagesImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 14px;
  object-fit: cover;
  cursor: move;
`;

export const AdImagesItemBtn = styled(Button)<{
  $position: BtnPosition;
  $isMirrored?: boolean;
  $isSmall?: boolean;
}>`
  position: absolute;
  cursor: pointer;

  ${({ $position, $isSmall }) => getStylesForBtnPosition($position, $isSmall)}

  ${({ $isMirrored }) =>
    !$isMirrored &&
    css`
      transform: rotateY(180deg);
      backface-visibility: visible;
    `}

  ${({ $isSmall }) =>
    $isSmall &&
    css`
      width: 20px;
    `}
`;

export const AdImagesLoadingIndicator = styled(IconBox)`
  ${centerAbsolute()}
  z-index: 1;
`;
